module.exports = __webpack_public_path__ + "static/About Image 2-3e17aa4b5ece6cb91406cba466e1ba4e.jpg";